import ProviderForm from "components/Provider/form"
import ProviderInForm from "components/ProviderIn/form"
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  getProviderCommodityClassifications,
  getProviderIps,
  getProviderItemCategories,
  getProviderProviders,
  getProviderProvinces,
  getProviderWarehouses,
} from "store/provider-dashboard/provider-dashboard-action"
import { storeProviderIn } from "store/provider-in/provider-in-action"
import { isObject } from "lodash"
import ProviderOutForm from "components/ProviderOut/form"
import {
  getProviderOutProviderAccounts,
  storeProviderOut,
  updateProviderOutDraftsToSubmitted,
} from "store/provider-out/provider-out-action"
import { providerOutAction } from "store/provider-out/provider-out-slice"

const AddProviderOut = () => {
  // Meta Tilte
  document.title = "Add Distribution"

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { loading, error } = useSelector(state => state.providerOut)

  // Retrieve warehouse data from Redux store
  const warehosues = useSelector(
    state => state.providerDashboard.providerWarehouses
  )
  // Retrieve providers data from Redux store
  const providers = useSelector(
    state => state.providerDashboard.providerProviders
  )

  // Retrieve categories data from Redux store
  const categories = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )

  // Retrieve ips data from Redux store
  const ips = useSelector(state => state.providerDashboard.ProviderIps)

  // Retrieve Unit Classification from Redux store
  const commodityClassifications = useSelector(
    state => state.providerDashboard.ProviderCommodityClassifications
  )

  // Retrieve providerAccounts data from Redux store
  const providerAccounts = useSelector(
    state => state.providerOut.providerAccounts
  )

  // Retrieve items data from Redux store
  const items = useSelector(state => state.providerIn.items)

  // Retrieve provinces data from Redux store
  const provinces = useSelector(
    state => state.providerDashboard.providerProvinces
  )

  // Retrieve facilities data from Redux store
  const facilities = useSelector(
    state => state.providerDashboard.providerFacilities
  )

  // Retrieve receipts data from Redux store
  const receipts = useSelector(state => state.providerOut.receipts)

  /*

    - handleSubmit: Triggered when the form is submitted
    - values: Contains the form input values and file
    - Dispatches the action to store the Provider Out with the provided values and file
  */
  const handleSubmit = (values, file) => {
    const document = new FormData()
    document.append("document", file)
    document.append("distributions", JSON.stringify(values))
    dispatch(storeProviderOut(document, navigate))
  }
  const handleFinalSubmit = () => {
    dispatch(updateProviderOutDraftsToSubmitted(navigate))
  }

  // fetch needed data based form select box
  useEffect(() => {
    dispatch(getProviderWarehouses())
    dispatch(getProviderProviders())
    dispatch(getProviderProvinces())
    dispatch(getProviderIps())
    dispatch(getProviderOutProviderAccounts())
    dispatch(getProviderCommodityClassifications())

    return () => {
      dispatch(providerOutAction.resetReceiptOut())
      dispatch(providerOutAction.resetProviderAccount())
    }
  }, [])

  return (
    // Provider out ( Distribution ) Form
    <ProviderOutForm
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      formMode={"Add"}
      warehosues={warehosues?.data}
      providers={providers?.data}
      categories={categories?.data}
      items={items?.data}
      ips={ips?.data}
      provinces={provinces?.data}
      facilities={facilities?.data}
      receipts={receipts?.data}
      providerAccounts={providerAccounts?.data}
      commodityClassifications={commodityClassifications?.data}
      onDraftSubmit={handleFinalSubmit}
    />
  )
}

export default AddProviderOut
